import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right-header-logout",
  "use": "icon-right-header-logout-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right-header-logout\"><path d=\"M822.224 200.864A440.016 440.016 0 0 1 200.24 823.136a440.016 440.016 0 0 1 0-622.272A44.016 44.016 0 0 1 262.4 263.072a351.984 351.984 0 1 0 497.52 0 44.016 44.016 0 0 1 62.256-62.208zM511.328 71.984c24.336 0 44.016 19.68 44.016 44.016V512a44.016 44.016 0 0 1-87.984 0V116c0-24.288 19.68-44.016 43.968-44.016z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/right-header-logout.svg
// module id = f2T6
// module chunks = 11